export const redirectToLogin = (returnPath = "/app") => {
  const params = new URLSearchParams({ return: returnPath })
  window.location.href = `/login?${params.toString()}`
}
